// TODO: probably should be encapsulated somewhere in a central place instead
export function removeDashes(s: string): string {
    return s.replace(/-/gi, '');
}
